





















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Accordion extends Vue {
  @Prop({ default: '' })
  private header !: string;

  @Prop({ default: () => [true] })
  private panel !: Array<boolean>;

  @Prop({ default: false })
  private disabled !: boolean;

  private open = this.panel;
}
